import React from 'react'

import { Image, ResponsiveValue } from '@gousto-internal/citrus-react'

import newBadgeSticker from '../../assets/NewBadgeAssets/new-badge.svg'

export type CWCNewBadgeProps = {
  /** Responsive width of the badge image, matching the Figma frame at each breakpoint. */
  width: ResponsiveValue<string>
  /** Responsive height of the badge image, matching the Figma frame at each breakpoint. */
  height: ResponsiveValue<string>
}

/**
 * Decorative "NEW" sticker, shared across CWC homepage sections.
 *
 * Purely decorative (a visual sticker, not information), so it renders with an empty alt and
 * `aria-hidden`, excluded from the accessible tree. Sizes differ per call site (Hero, What's New,
 * Weekly Menu toggle), so `width`/`height` are required rather than defaulted — the consuming
 * section positions it via composition (e.g. wrapping it in a positioned Box). Sourced as an SVG
 * (vector) rather than a raster format, since it's a flat-colour illustration with no
 * photographic content — an SVG scales crisply at every breakpoint and stays cheap
 * (~6KB) regardless of render size.
 */
export const CWCNewBadge = ({ width, height }: CWCNewBadgeProps) => (
  <Image
    data-testid="newBadge"
    src={newBadgeSticker}
    alt=""
    aria-hidden
    width={width}
    height={height}
  />
)
